import { Separator } from "@qw/ui";
import { Outlet } from "react-router";
import { AppNav } from "@/app/app-nav";
import { BankanNav } from "./bankan-nav";

export const BankanLayout = () => (
  <>
    <AppNav />
    <main className="overflow-hidden">
      <BankanNav />
      <Separator orientation="vertical" />
      <Outlet />
    </main>
  </>
);
